import { DatepickerPopupController, InputBase } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

import { Objects } from "@salaxy/core";

/**
 * Modified ui.bootstrap.datepickerPopup.
 * The component can be bound to a string typed variable. The standard ui.bootstrap.datepickerPopup can be bound successfully only to a Date variable.
 * @example
 * ```html
 *
 * <salaxy-datepicker-popup name="myDatepickerPopup" ng-model="temp" label="Basic datepicker popup"></salaxy-datepicker-popup>
 * ```
 */
export class DatepickerPopup extends ComponentBase {

  /** ng-model is required, form tag is optionally used for validation and disabled/readonly */
  public require = {
    model: "ngModel",
    form: "?^^form",
  };

  /**
   * The following component properties (attributes in HTML) are bound to the Controller.
   * For detailed functionality, refer to [controller](#controller) implementation.
   */
  public bindings = Objects.extend(InputBase.crudBindings, {
    /** Format for the date, default is d.M.yyyy */
    format: "@",

    /**
     * Preset algorithms for enabled/disabled dates.
     * Currently, only "salary" is supported for salary dates, but more might be added later.
     * If set as "disable-function", you should set the disable-function too.
     */
    dateDisabled: "@",

    /** Disable function for date. If set, date-disabled is ignored. */
    disableFunction: "<",

    /** Payment channel. This affects which dates are disabled in the salary date selection. */
    paymentChannel: "<",

    /** Zero payment (no worker net salary payment). This affects which dates are disabled in the salary date selection. */
    zeroPayment: "<",

    /**
     * Minimum available date.
     * Bindable and ISO string version of the datepicker-options.minDate.
     * Currently not supported together with dateDisabled filters.
     */
    minDate: "<",

    /**
     * Maximum available date.
     * Bindable and ISO string version of the datepicker-options.maxDate.
     * Currently not supported together with dateDisabled filters.
     */
    maxDate: "<",

    /** ng-change callback */
    ngChange: "&?",

    /**
     * External value that causes the disabled dates function to re-run.
     */
    updateDisabledDates: "<",
  });

  /** Uses the DatepickerController */
  public controller = DatepickerPopupController;

  /** The default template for the component. */
  public defaultTemplate = "salaxy-components/form-controls/DatepickerPopup.html";
}